<template>
  <div>
    <el-upload
      :action="`${this.$store.state.upBaseUrl}coupon-market/activity/fileCouponModelUpload`"
      :headers="myHeaders"
      :limit="1"
      ref="uploadModel"
      accept=".txt"
      :on-success="handleAvatarSuccess"
      :auto-upload="true">
      <el-button slot="trigger" size="mini" type="primary">选取机型文件</el-button>
      <div slot="tip" class="el-upload__tip">只能上传txt文件，每次只能上传一个文件</div>
    </el-upload>
  </div>
</template>

<script>
  export default {
    props:{
      //数据列表
      dataList: {
       type: Array,
       default() {
          return []
       }
      },
    },
    data() {
      return {
        myHeaders:{},
        list:[]
      };
    },
    created(){
      var token =  window.sessionStorage.getItem('token');
      this.myHeaders = {'oa-token':token}
    },
    methods: {
      handleAvatarSuccess(res, file) {
        if (res.code == 0) {
          this.$emit('setPhoneModel',res.data)
          this.$alert('上传成功!', '提示', {
            confirmButtonText: '确定',
          });
        }
      },
      handleClear() {
        console.log("子组件方法");
        this.$refs.uploadModel.clearFiles();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/phoneModel.vue